import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { FileDown, ExternalLink } from "lucide-react";

const PressPage = () => {
  const { t, language } = useLanguage();

  const pressArticles = [
    {
      title: {
        pl: "Sam Childers - kaznodzieja z karabinem",
        en: "Sam Childers - Machine Gun Preacher",
        ru: "Сэм Чайлдерс - проповедник с оружием",
        uk: "Сем Чайлдерс - проповідник зі зброєю",
      },
      source: "Pytanie na Śniadanie",
      logo: "https://s.tvp.pl/files/portale-v4/pytanie-na-sniadanie/images/pns-logo2.png",
      url: "https://pytanienasniadanie.tvp.pl/77742054/sam-childers-kaznodzieja-z-karabinem",
      cta: {
        pl: "przeczytaj i zobacz wywiad",
        en: "read and watch the interview",
        ru: "прочитать и посмотреть интервью",
        uk: "прочитати та подивитися інтерв'ю",
      },
    },
    {
      title: {
        pl: "Kaznodzieja Z Karabinem W Polsce | News Express",
        en: "Machine Gun Preacher in Poland | News Express",
        ru: "Проповедник с Оружием в Польше | News Express",
        uk: "Проповідник зі Зброєю в Польщі | News Express",
      },
      source: "TBN Polska",
      logo: "https://yt3.ggpht.com/x2Zu-EvEAb5viREUPl9eS-GdumbT9hy76SkbEgI_zOHiqzE4zIJokS7YUVxaR5P9jBVq_gwgmQ=s88-c-k-c0x00ffffff-no-rj",
      url: "https://www.youtube.com/watch?v=RlOANox6SIE",
      cta: {
        pl: "zobacz wywiad na youtube",
        en: "watch the interview on youtube",
        ru: "смотреть интервью на youtube",
        uk: "дивитися інтерв'ю на youtube",
      },
    },
    {
      title: {
        pl: "Sam Childers: Niektórym się wydaje, że jestem jakimś wariatem z bronią",
        en: "Sam Childers: Some people think I'm some kind of gun-toting maniac",
        ru: "Сэм Чайлдерс: Некоторые думают, что я какой-то маньяк с оружием",
        uk: "Сем Чайлдерс: Деякі думають, що я якийсь маніяк зі зброєю",
      },
      source: "Interia",
      logo: "https://whatthelogo.com/storage/logos/interia-283726.png",
      url: "https://film.interia.pl/wywiady/news-sam-childers-niektorym-sie-wydaje-ze-jestem-jakims-wariatem-,nId,2360338",
      cta: {
        pl: "przeczytaj wywiad",
        en: "read the interview",
        ru: "прочитать интервью",
        uk: "прочитати інтерв'ю",
      },
    },
    {
      title: "Sam Childers",
      source: "Wikipedia",
      logo: "https://pl.wikipedia.org/static/images/icons/wikipedia.png",
      url: "https://pl.wikipedia.org/wiki/Sam_Childers",
      cta: {
        pl: "przeczytaj artykuł na wikipedii",
        en: "read the article on wikipedia",
        ru: "прочитать статью в википедии",
        uk: "прочитати статтю у вікіпедії",
      },
    },
    {
      title: {
        pl: "KAZNODZIEJA Z KARABINEM – historia Sama Childersa",
        en: "MACHINE GUN PREACHER – Sam Childers' Story",
        ru: "ПРОПОВЕДНИК С ОРУЖИЕМ – история Сэма Чайлдерса",
        uk: "ПРОПОВІДНИК ЗІ ЗБРОЄЮ – історія Сема Чайлдерса",
      },
      source: "WDJ TV",
      logo: "https://yt3.ggpht.com/Q_118BR5qx35-tWJLn2vHcgs5iwAPiUwq91nMHHmSZ8vfFSgZfq2tsUFOrQN4_RTFB3uIfnUGzs=s88-c-k-c0x00ffffff-no-rj",
      url: "https://www.youtube.com/watch?v=LsZLGlqTSgU",
      cta: {
        pl: "zobacz historię Sama na youtube",
        en: "watch Sam's story on youtube",
        ru: "смотреть историю Сэма на youtube",
        uk: "дивитися історію Сема на youtube",
      },
    },
    {
      title: {
        pl: "WS#1 Kaznodzieja z karabinem / SE#1 Machinegun Preacher",
        en: "SE#1 Machine Gun Preacher",
        ru: "SE#1 Проповедник с Оружием",
        uk: "SE#1 Проповідник зі Зброєю",
      },
      source: "BSTv",
      logo: "https://yt3.ggpht.com/ytc/AIdro_ni2Leq-41CsflTNPPrQ2o6RnTvxJpGeVwEBB9jg9AdYx8=s88-c-k-c0x00ffffff-no-rj",
      url: "https://www.youtube.com/watch?v=Gm_htHLPrjU",
      cta: {
        pl: "Obejrzyj wideo na youtube",
        en: "Watch the video on youtube",
        ru: "Смотреть видео на youtube",
        uk: "Дивитися відео на youtube",
      },
    },
    {
      title: {
        pl: "Sam Childers: Jak działa fundacja Angels of East Africa?",
        en: "Sam Childers: How does Angels of East Africa foundation work?",
        ru: "Сэм Чайлдерс: Как работает фонд Angels of East Africa?",
        uk: "Сем Чайлдерс: Як працює фонд Angels of East Africa?",
      },
      source: "Telewizja TVT",
      logo: "https://yt3.ggpht.com/cfvS9xPa8blv11zaUcNu_GmNXW7s1XBQAmDcEZK-XL9kfAd7OB_8eL5wEeLRqQq-ePnB0OPA=s88-c-k-c0x00ffffff-no-rj",
      url: "https://www.youtube.com/watch?v=gcT8vHf0RjA",
      cta: {
        pl: "Obejrzyj na youtube",
        en: "Watch on youtube",
        ru: "Смотреть на youtube",
        uk: "Дивитися на youtube",
      },
    },
    {
      title: {
        pl: "Weekend w Tarnowie i okolicach",
        en: "Weekend in Tarnów and surroundings",
        ru: "Выходные в Тарнове и окрестностях",
        uk: "Вихідні в Тарнові та околицях",
      },
      source: "Tarnów Gazeta Wydarzenia i Wiadomości",
      logo: "https://tarnow.ikc.pl/wp-content/uploads/2022/12/Tarnow_IKC_PL.png",
      url: "https://tarnow.ikc.pl/weekend-w-tarnowie-i-okolicach-juwenalia-i-dzien-matki/",
      cta: {
        pl: "przeczytaj relację",
        en: "read the report",
        ru: "прочитать отчет",
        uk: "прочитати звіт",
      },
    },
  ];

  const pressMaterials = [
    {
      title: {
        pl: "Press Pack dla mediów",
        en: "Press Pack for media",
        ru: "Пресс-пакет для СМИ",
        uk: "Прес-пакет для ЗМІ",
      },
      description: {
        pl: "Kompletny pakiet prasowy zawierający informacje dla mediów",
        en: "Complete press package containing information for media",
        ru: "Полный пресс-пакет, содержащий информацию для СМИ",
        uk: "Повний прес-пакет, що містить інформацію для ЗМІ",
      },
      url: "https://docs.google.com/document/d/19ss9TvTADJFs_FNXUBCss6ckBUjXEh1JlreZlRmaRL8/edit?usp=sharing",
      icon: "FileText",
    },
    {
      title: {
        pl: "Biografia Sama Childersa",
        en: "Sam Childers Biography",
        ru: "Биография Сэма Чайлдерса",
        uk: "Біографія Сема Чайлдерса",
      },
      description: {
        pl: "Szczegółowa biografia i historia życia Sama Childersa",
        en: "Detailed biography and life story of Sam Childers",
        ru: "Подробная биография и история жизни Сэма Чайлдерса",
        uk: "Детальна біографія та історія життя Сема Чайлдерса",
      },
      url: "https://docs.google.com/document/d/182EfpCs51iHKtwZxqsClwVdQaEQUzKXGUEHXgxrLeG4/edit?usp=sharing",
      icon: "Book",
    },
    {
      title: {
        pl: "Zdjęcia i grafiki do użytku mediów",
        en: "Photos and graphics for media use",
        ru: "Фотографии и графика для использования в СМИ",
        uk: "Фотографії та графіка для використання в ЗМІ",
      },
      description: {
        pl: "Kolekcja zdjęć i grafik wysokiej rozdzielczości do wykorzystania przez media",
        en: "Collection of high-resolution photos and graphics for media use",
        ru: "Коллекция фотографий и графики высокого разрешения для использования в СМИ",
        uk: "Колекція фотографій та графіки високої роздільної здатності для використання в ЗМІ",
      },
      url: "https://drive.google.com/drive/folders/15-UKFmI-wPjbMxjrq8VAWEiUNzJG4yia?usp=sharing",
      icon: "Image",
    },
  ];

  return (
    <div className="pt-16">
      <div className="bg-secondary">
        <div className="container mx-auto py-16 px-4 md:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {t("nav.press")}
          </h1>
          <p className="text-xl text-muted-foreground">
            {t("press.description")}
          </p>
        </div>
      </div>

      <div className="container mx-auto py-12 px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-6">{t("press.downloads")}</h2>
            <div className="space-y-4">
              {pressMaterials.map((material, index) => (
                <div
                  key={index}
                  className="p-6 bg-card rounded-lg border border-border hover:border-primary transition-colors"
                >
                  <div className="flex flex-col">
                    <h3 className="font-bold text-lg mb-2">
                      {material.title[language]}
                    </h3>
                    <p className="text-muted-foreground text-sm mb-4">
                      {material.description[language]}
                    </p>
                    <Button
                      variant="outline"
                      size="sm"
                      className="self-start gap-2 items-center"
                      asChild
                    >
                      <a
                        href={material.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FileDown className="h-4 w-4" />
                        {t("press.open")}
                      </a>
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-6">{t("press.articles")}</h2>
            <div className="space-y-4">
              {pressArticles.map((article, index) => (
                <div
                  key={index}
                  className="p-6 bg-card rounded-lg border border-border"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 relative flex-shrink-0">
                      <img
                        src={article.logo}
                        alt={article.source}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">
                        {typeof article.title === "string"
                          ? article.title
                          : article.title[language]}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {article.source}
                      </p>
                    </div>
                  </div>
                  <Button
                    variant="link"
                    className="p-0 h-auto gap-2 items-center"
                    asChild
                  >
                    <a
                      href={article.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center"
                    >
                      {article.cta[language]}
                      <ExternalLink className="h-4 w-4 ml-2" />
                    </a>
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-2xl font-bold mb-6">{t("press.contact")}</h2>
          <div className="p-6 bg-secondary rounded-lg">
            <p className="mb-4">{t("press.contact.description")}</p>
            <div className="space-y-2">
              <div className="mb-4">
                <strong>{t("contact.form.name")}</strong> Marta Rassek
              </div>
              <p>
                <strong>Email:</strong> marta@arka.org.pl
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PressPage;
